import {
  lastLoginMethodClient,
  magicLinkClient,
  oneTapClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  baseURL: process.env.NEXT_PUBLIC_APP_URL || "http://localhost:3000",
  plugins: [
    magicLinkClient(),
    oneTapClient({
      clientId: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID || "",
      promptOptions: {
        fedCM: true,
      },
      additionalOptions: {
        use_fedcm_for_prompt: true,
      },
    }),
    lastLoginMethodClient(),
  ],
});

export const { signIn, signOut, useSession, getSession } = authClient;
